const scrollInit = () => {
  const header: HTMLElement = document.querySelector('.header');
  const sticky: HTMLElement = document.querySelector('.sticky-cart');
  const body: HTMLBodyElement = document.querySelector('.body');

  const Scroll = {
    header: window.innerWidth < 992 ? 1 : 33,
    stickyCart: 130,
  };

  const Class = {
    header: 'header--sticky',
    stickyCart: 'sticky-cart--active',
    body: 'body--sticky',
  };

  const toggleClass = (e: HTMLElement, aClass: string, scroll: number, bodyChange: boolean) => {
    if (window.scrollY > scroll) {
      e?.classList.add(aClass);

      if (bodyChange) {
        body.classList.add(Class.body);
      }
    } else {
      e?.classList.remove(aClass);

      if (bodyChange) {
        body.classList.remove(Class.body);
      }
    }
  };

  document.addEventListener('scroll', () => {
    if (header) {
      toggleClass(header, Class.header, Scroll.header, true);
    }

    if (sticky) {
      toggleClass(sticky, Class.stickyCart, Scroll.stickyCart, false);
    }
  });
};

export default scrollInit;
